// store/modules/content.js

import axios from 'axios'
const state = {
  content: {},
  meta: {}
}
const getters = {
  content: (state) => state.content,
  meta: (state) => state.meta
}
const actions = {
  async getContent ({ commit, rootState }) {
    return await axios.get('/content?fields=*.*')
      .then(response => {
        commit('contentData', response.data)
      })
  },
  async getMeta ({ commit, rootState }) {
    return await axios.get('/meta')
      .then(response => {
        commit('metaData', response.data)
      })
  }
}
const mutations = {
  contentData: (state, content) => (state.content = content),
  metaData: (state, meta) => (state.meta = meta)
}
export default {
  state,
  getters,
  actions,
  mutations
}
